import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/hospital.png'


const _hoisted_1 = {
  class: "card border-0 rounded-3 mb-4",
  style: {"background-color":"#fff5ed"}
}
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-12" }
const _hoisted_7 = { class: "position-relative z-1" }
const _hoisted_8 = { class: "card bg-white p-4 border-0 rounded-3 mb-0 exchange-for-dark" }
const _hoisted_9 = { class: "row align-items-center" }
const _hoisted_10 = { class: "col-lg-5" }
const _hoisted_11 = { style: {"margin":"-30px -10px -30px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-30\"><h3 class=\"mb-0\">Hospital Earnings</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90 bg-transparent\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Week</option><option value=\"1\">Last Month</option><option value=\"2\">Last Year</option></select></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-5" }, [
          _createElementVNode("div", { class: "hospital-img pt-3 pb-4 text-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "hospital"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"col-sm-6\"><div class=\"card bg-white p-4 border-0 rounded-3 mb-4 exchange-for-dark\"><h2 class=\"fs-24 fw-medium mb-1\">$120,000</h2><p class=\"fs-12 mb-0\"> Total Profit <span class=\"text-danger ms-1\"><i class=\"ri-arrow-down-fill\"></i> 5% </span></p></div></div><div class=\"col-sm-6\"><div class=\"card bg-white p-4 border-0 rounded-3 mb-4 exchange-for-dark\"><h2 class=\"fs-24 fw-medium mb-1\">$80,000</h2><p class=\"fs-12 mb-0\"> Total Costs <span class=\"text-success ms-1\"><i class=\"ri-arrow-up-fill\"></i> 3% </span></p></div></div>", 2)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"col-lg-7\"><h2 class=\"fs-24 fw-medium mb-1\">$900,000</h2><p class=\"fs-12 mb-0\"> Total Earnings <span class=\"text-success ms-1\"><i class=\"ri-arrow-up-fill\"></i> 3% </span></p></div>", 1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.isClient)
                          ? (_openBlock(), _createBlock(_component_apexchart, {
                              key: 0,
                              type: "area",
                              height: "95",
                              options: _ctx.hospitalEarnings,
                              series: _ctx.hospital
                            }, null, 8, ["options", "series"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg-white bg-opacity-75 p-2 p-md-3 mx-3 mx-md-5 rounded-bottom-3 exchange-for-dark" }, null, -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}